import { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { GROUP_COLOR_MAP } from '@/utils/groupColors'

interface RoomGroupProps {
  title: string
  count: number
  dotColor: string
  defaultOpen?: boolean
  children: React.ReactNode
}

export function RoomGroup({
  title,
  count,
  dotColor,
  defaultOpen = true,
  children,
}: RoomGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  if (count === 0) return null

  const colors = GROUP_COLOR_MAP[dotColor] ?? GROUP_COLOR_MAP['slate']

  return (
    <div className='mb-6'>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className='flex gap-3 items-center mb-3 w-full text-left group'
      >
        <span
          className='w-2.5 h-2.5 rounded-full flex-shrink-0'
          style={{ backgroundColor: colors.dot }}
        />
        <span className='text-sm font-semibold tracking-wide uppercase text-slate-700 group-hover:text-slate-900'>
          {title}
        </span>
        <span
          className='inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-semibold'
          style={{ backgroundColor: colors.badgeBg, color: colors.badgeText }}
        >
          {count}
        </span>
        <span className='ml-auto text-slate-400 group-hover:text-slate-600'>
          {isOpen ? (
            <ChevronDown className='w-4 h-4' />
          ) : (
            <ChevronRight className='w-4 h-4' />
          )}
        </span>
      </button>

      {isOpen && (
        <div className='grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'>
          {children}
        </div>
      )}
    </div>
  )
}
